import { LinkItem } from '@occc-app/design-system';

import { routeCreator } from '../../../messaging-center.utils';

export const getPageLinks = (pageLabel: string): LinkItem[] => [
  {
    to: routeCreator.campaignsList(),
    label: 'Messaging Campaigns',
    key: 'messaging-campaigns-list-page',
  },
  {
    label: pageLabel,
    key: 'messaging-campaigns-configure-page',
  },
];
